import { DEFAULT_API_CONFIG } from './apiConfig';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/client`;
const baseAccountRoute = `${url}/account`;
const baseUserClientRoute = `${url}/user/clients`;

export const getClientList = async () => {
  const url = `${baseRoute}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getClientListSelectVM = async () => {
  const url = `${baseRoute}/SelectVM`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getClient = async clientId => {
  const url = `${baseRoute}/${clientId}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getVirtualProviders = async () => {
  const url = `${baseRoute}/VirtualProviders`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};


export const getVirtualValuationProviders = async () => {
  const url = `${baseRoute}/VirtualValuationProviders`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};


export const getClientConfiguration = async clientId => {
  const url = `${baseRoute}/configuration/${clientId}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getClientCallConfiguration = async clientId => {
  const url = `${baseRoute}/CallConfiguration/${clientId}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  console.log('response', response);

  try {
    const json = await response.json();
    console.log('json', json);
    return response.ok ? json : Promise.reject(json);
  } catch (error) {
    // console.error('Error parsing JSON:', error);
    // return Promise.reject(new Error('Invalid response format'));
  }
};

/**
 * Valuation FIT configuration: GET and PUT use `client/ValuationFITConfiguration/{clientId}`.
 * PUT body should match the JSON shape returned by GET.
 */
export const getValuationFitConfiguration = async clientId => {
  const url = `${baseRoute}/ValuationFITConfiguration/${clientId}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const text = await response.text();
  let json;
  try {
    json = text ? JSON.parse(text) : null;
  } catch {
    json = null;
  }
  return response.ok ? json : Promise.reject(json || new Error(text || `Request failed (${response.status})`));
};

const parseValuationFitPutError = text => {
  if (!text || !String(text).trim()) {
    return 'Request failed';
  }
  try {
    const body = JSON.parse(text);
    if (typeof body === 'string') {
      return body;
    }
    if (body && typeof body === 'object') {
      const msg =
        body.exceptionMessage ||
        body.ExceptionMessage ||
        body.innerException?.message ||
        body.InnerException?.Message ||
        body.message ||
        body.Message ||
        body.detail ||
        body.title ||
        body.error ||
        (typeof body.errors === 'string' ? body.errors : null);
      if (msg) {
        return String(msg);
      }
      if (Array.isArray(body.errors)) {
        return body.errors.map(e => (typeof e === 'string' ? e : e?.message || JSON.stringify(e))).join('; ');
      }
    }
  } catch {
    /* not JSON */
  }
  return String(text).trim();
};

/**
 * PUT returns empty 200 on success; 400 with an exception payload on failure.
 */
export const saveValuationFitConfiguration = async (clientId, payload) => {
  const url = `${baseRoute}/ValuationFITConfiguration/${clientId}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(payload),
  });
  if (response.ok) {
    return true;
  }
  const text = await response.text();
  return Promise.reject(new Error(parseValuationFitPutError(text)));
};

export const getClientPersonEmails = async id => {
  const url = `${baseRoute}/PersonEmails/${id}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const createClient = async clientObj => {
  const url = `${baseRoute}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(clientObj),
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const updateClient = async clientObj => {
  const url = `${baseRoute}/${clientObj.id}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(clientObj),
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const saveClientConfiguration = async clientConfig => {
  const url = clientConfig.clientId ? `${baseRoute}/configuration` : `${baseRoute}/configuration`;
  const method = clientConfig.clientId ? 'PUT' : 'POST';
  const headers = getHeaders();
  const response = await fetch(url, {
    method,
    headers,
    body: JSON.stringify(clientConfig),
  });

  if (response.status >= 200 || response.status < 300) {
    return true;
  }

  return Promise.reject(new Error('Failed to save'));
};

export const saveClientCallConfiguration = async clientConfig => {
  const url = `${baseRoute}/ClientCallConfiguration`;
  const method = 'PUT';
  const headers = getHeaders();
  const response = await fetch(url, {
    method,
    headers,
    body: JSON.stringify(clientConfig),
  });

  if (response.status >= 200 || response.status < 300) {
    return true;
  }

  return Promise.reject(new Error('Failed to save'));
};

export const updateClientLogo = async (clientId, image) => {
  const url = `${baseRoute}/${clientId}/Logo`;

  let formData = new FormData();
  formData.append('image', image);

  let headers = {};
  const token = localStorage.getItem('token');
  if (token) {
    headers = {
      Authorization: `Bearer ${token}`,
    };
  }

  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: formData,
  });

  return response.ok ? response : Promise.reject(await response.json());
};

export const getAllClientUsers = async () => {
  const url = `${baseUserClientRoute}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getClientUserById = async id => {
  const url = `${baseUserClientRoute}/${id}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const createClientUser = async user => {
  user.role = 'CLIENT';

  const url = `${baseAccountRoute}/RegisterUser`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(user),
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const putClientUser = async user => {
  user.role = 'CLIENT';
  const url = `${baseAccountRoute}/UpdateUser`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(user),
  });
  return response;
};

export const getAgents = async q => {
  const url = `${baseRoute}/Agents`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getAgentsByClientId = async clientId => {
  const url = `${baseRoute}/Agents?clientId=${clientId}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const saveMasterAgentByAgentId = async (data, masterAgentId) => {
  const url = `${baseRoute}/Agents/${masterAgentId}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(data),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getAgentById = async agentMasterId => {
  const url = `${baseRoute}/Agents/${agentMasterId}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getAgentOptions = async (options = {}) => {
  const q = queryString.stringify(options);
  const url = `${baseRoute}/Agents/options?${q}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getAvailableReportCodes = async clientId => {
  const url = `${baseRoute}/${clientId}/AvailableReportCodes`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getClientSpecialInstructions = async clientId => {
  const url = `${baseRoute}/SpecialInstructions/${clientId}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const updateClientSpecialInstructions = async (clientId, clientSpecialInstructions) => {
  const url = `${baseRoute}/SpecialInstructions/${clientId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(clientSpecialInstructions),
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const createClientSpecialInstructions = async clientSpecialInstructions => {
  const url = `${baseRoute}/SpecialInstructions/${clientSpecialInstructions.clientId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(clientSpecialInstructions),
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const createAgent = async agentVM => {
  const url = `${baseRoute}/agents`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(agentVM),
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const getClientPriceOverrideProducts = async () => {
  const url = `${baseUserClientRoute}/PriceOverride/Products`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getClientPriceOverrides = async clientId => {
  const url = `${baseUserClientRoute}/${clientId}/PriceOverride`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const updateClientPriceOverrides = async (priceOverrideVM, updateClient = false) => {
  const url = `${baseUserClientRoute}/PriceOverride?updateClient=${updateClient}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(priceOverrideVM),
  });

  if (!response.ok) {
    throw await response.text();
  }

  return response.ok;
};

export const getClientSupplements = async clientId => {
  const url = `${baseUserClientRoute}/PriceOverride/Supplements`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getClientSuppOverrides = async clientId => {
  const url = `${baseUserClientRoute}/${clientId}/Supp`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getClientInvisionIQKpis = async queryParams => {
  const query = queryString.stringify(queryParams);
  let url = `${baseRoute}/InVisionIQKPIs?${query}`;

  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getClientInvisionIQKpiGrid = async queryParams => {
  const query = queryString.stringify(queryParams);
  let url = `${baseRoute}/InVisionIQKPIGrid?${query}`;

  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getClientInvisionIQKpiFilters = async queryParams => {
  const query = queryString.stringify(queryParams);
  let url = `${baseRoute}/InVisionIQKPIFilters?${query}`;

  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getByteFileForClientPriceOverrides = async () => {
  let url = `${baseUserClientRoute}/exportClientPriceOverrides`;

  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getAccountXRefsByClientId = async clientId => {
  const getUrl = `${url}/ClientAccounts/ByClientId/${clientId}`;
  let headers = getHeaders();
  const response = await fetch(getUrl, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
}
